import DataSyncModal from 'growth-data-modal/components/DataSyncModal';
import { useTracker } from '../../../hooks/tracking';
import { useImportContactTaskIdFromList } from '../../../hooks/dataSyncContactsCard';
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataSyncTaskModalContainer({
  onClose,
  onOpenModal
}) {
  const {
    importContactTaskId,
    isLoading: isLoadingTaskData
  } = useImportContactTaskIdFromList();
  const {
    tracker
  } = useTracker();
  if (isLoadingTaskData) {
    return null;
  }
  return /*#__PURE__*/_jsx(DataSyncModal, {
    hostApp: "user-guide",
    onClose: onClose,
    onOpen: onOpenModal,
    trackerInstance: tracker,
    withMarketplaceRedirectParams: {
      via: 'user-guide'
    },
    withSyncRedirectParams: Object.assign({
      via: 'user-guide-data-sync-modal',
      onboarding_referrer_group: FREE_GROUP_KEYS.setUpTheBasics
    }, importContactTaskId && {
      onboarding_referrer_task: String(importContactTaskId)
    })
  });
}